import React from 'react';
import ReactDOM from 'react-dom';
import Immutable from 'immutable';
import 'url-polyfill';
import 'url-search-params-polyfill';
import 'core-js/es6/symbol';
import 'core-js/fn/array/entries';
import 'core-js/fn/array/every';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/from';
import 'core-js/fn/object/entries';
import 'core-js/fn/object/values';
import 'core-js/fn/string/includes';
import 'core-js/fn/set';
import 'core-js/fn/map';
import App from '@debatdirect/debatdirect-modules/containers/App/App';
import { service, structure } from '@debatdirect/debatdirect-modules/core';
import {
  ConnectionHandler,
  createRootComponent,
  fetchMainFeeds,
  InitError,
  ResizeHandler,
  SplashScreenHandler,
  urlParams
} from '@debatdirect/debatdirect-modules/bootstrap';
import services from './services';
import RouterView from './view/RouterView';
import config from './config';
import routes from './routes';
import { injectPlayer, injectStats, injectCastSender } from './di';
import './scss/index.scss';

const { ServiceContainer } = service;

// Save the initialUrl
const initialUrl = window.location.href;
const initialUrlParams = new URLSearchParams(window.location.search);

injectPlayer();
injectStats();
injectCastSender();

/**
 * Get cursor from structure
 * @param {Array} keyPath
 * @returns {*}
 */
const getCursor = (keyPath) => {
  return structure.cursor(keyPath);
};

/**
 * Initialize.
 */
const init = () => {

  // Update structure with config and url parameters.
  structure.cursor()
    .setIn(['config'], Immutable.fromJS(config))
    .setIn(['ui', 'settings', 'baseUrl'], config.baseUrl)
    .setIn(['ui', 'settings', 'hd'], initialUrlParams.get('hd') === '1')
    .setIn(['ui', 'settings', 'api', 'baseUrl'], config.api.baseUrl)
    .setIn(['ui', 'width'], document.body.offsetWidth)
    .setIn(['ui', 'seekEvent'], urlParams.getInitialEvent())
    .setIn(['ui', 'entryParams'], urlParams.getUrlParams().raw)
    .setIn(['auth', 'initialUrl'], initialUrl);

  // Show splash screen.
  SplashScreenHandler.show(config.staticUrl);

  // Initialize connection handler.
  ConnectionHandler.init(structure, ServiceContainer);

  // Initialize resize handler.
  ResizeHandler.init(structure);

  // Initialize app.
  App({
    ...config,
    structure,
    routes,
    services
  });

  // Add touch-device class to HTML element if appropriate.
  if (ServiceContainer.get('platform').isTouchDevice()) {
    document.documentElement.classList.add('touch-device');
  }

  ServiceContainer
    .get('status')
    .start();

  ServiceContainer
    .get('preference')
    .init();

  ServiceContainer
    .get('live')
    .start();

  // Fetch feeds.
  fetchFeeds();
};

/**
 * Fetch feeds.
 */
const fetchFeeds = () => {

  fetchMainFeeds()
    .then(initView, () => {

      InitError.show(InitError.DATA_ERROR);
      setTimeout(fetchFeeds, 20000); // Try again in 20 seconds.
    });
};

/**
 * Initialize view.
 */
let initView = () => {

  // Go to route.
  // routeToPathname(config, ServiceContainer.get);

  // Hide error.
  InitError.hide();

  // Fade out splash screen.
  SplashScreenHandler.hide();

  // Create root component.
  const RootComponent = createRootComponent(RouterView, getCursor, ServiceContainer.get);

  // Render root component.
  ReactDOM.render(<RootComponent cursor={getCursor()} />, document.querySelector('.AppView'));

  if (process.env.NODE_ENV !== 'production') {
    structure.on('swap', function (curr, prev, keypath) {
      console.log('swap(' + keypath.join('->') + ')');
    });

    window.structure = structure;
  }

  // Override init view to prevent multiple calls.
  initView = function () {
  };
};

/**
 * Call init.
 */
init();



// WEBPACK FOOTER //
// ./src/index.js